import * as ngCdkOverlay from '@angular/cdk/overlay'
import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../state'

import * as handle from './handle'
import * as popUp from './pop-up'

/**
 * AI assistant to help users write better content
 */
@ngCore.Component({
  imports: [
    ds.overlay.attached.Component,
    ngCdkOverlay.CdkOverlayOrigin,
    handle.Component,
    popUp.Component,
  ],
  selector: 'atn-platform-writing-helper',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.writingHelper.Feature} */
  public readonly writingHelperFeature = ngCore.inject(
    state.writingHelper.Feature,
  )
}
